export const LANGUAGE_DE = 'de';
export const LANGUAGE_FR = 'fr';
export const LANGUAGES = [LANGUAGE_DE, LANGUAGE_FR] as const;

export type Languages = (typeof LANGUAGES)[number];
